import { createTheme, type Theme } from '@mui/material/styles';
import { createContext, useContext } from 'react';

// Hut 8 brand tokens — per skills/hut8-ui.
// Light is the default (SGO 06/12); the nav toggle flips to dark and the
// choice persists in localStorage.
export type ColorMode = 'light' | 'dark';

export const MODE_STORAGE_KEY = 'app-registry-color-mode';

export function buildTheme(mode: ColorMode): Theme {
  return createTheme({
    palette:
      mode === 'light'
        ? {
            mode: 'light',
            primary: { main: '#3D7A00', contrastText: '#FFFFFF' },
            background: { default: '#FAFAFA', paper: '#FFFFFF' },
            text: { primary: '#111111', secondary: 'rgba(17,17,17,0.65)' },
          }
        : {
            mode: 'dark',
            primary: { main: '#B4FE00', contrastText: '#0A0A0A' },
            background: { default: '#0A0A0A', paper: '#111111' },
            text: { primary: '#FAFAFA', secondary: 'rgba(250,250,250,0.7)' },
          },
    typography: {
      fontFamily: 'Inter, system-ui, sans-serif',
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: { borderRadius: 8 },
  });
}

export const ColorModeContext = createContext<{ mode: ColorMode; toggle: () => void }>({
  mode: 'light',
  toggle: () => {},
});

export const useColorMode = () => useContext(ColorModeContext);
